import {
  Button,
  buttonStylesGhost,
  buttonStylesPrimary,
  debounce,
  getDescriptionForItemCount,
  Search,
  useClassNames,
} from '@h2oai/ui-kit';
import { useCallback, useMemo, useState } from 'react';

import { ActivePermission, Project } from '../../featurestore/gen/ai/h2o/featurestore/api/v1/CoreService.pb';
import { buttonStylesPrimaryPanel, ContentsTitle } from '../../featurestore/models';
import { ProjectList } from '../ProjectList/ProjectList';
import { ISelectProjectClassNames, ISelectProjectStyles, selectProjectStylesDefault } from './SelectProject.styles';

interface ISelectProjectProps {
  onSelect: (project?: Project) => void;
  onCancel?: () => void;
  onUpdateList?: (count: number, pageSize: number, pageToken: string, name: ContentsTitle) => void;
}

export const SelectProject = ({ onSelect, onCancel, onUpdateList }: ISelectProjectProps) => {
  const [searchText, setSearchText] = useState('');
  const [description, setDescription] = useState('');
  const [project, setProject] = useState<Project>();
  const changeSearchText = useCallback((text: string) => {
    setSearchText(text);
  }, []);
  const onSearchTextChange = useMemo(() => debounce(300, changeSearchText), [changeSearchText]);
  const onUpdateData = useCallback((count: number, pageSize: number, pageToken: string, name: ContentsTitle) => {
    setDescription(getDescriptionForItemCount(count, pageSize, pageToken, name));
    onUpdateList && onUpdateList(count, pageSize, pageToken, name);
  }, []);
  const classNames = useClassNames<ISelectProjectStyles, ISelectProjectClassNames>(
    'SelectProject',
    selectProjectStylesDefault
  );
  return (
    <div className={classNames.root}>
      <Search placeholder="Search by name" onSearchTextChange={onSearchTextChange} />
      <div className={classNames.description}>{description}</div>
      <ProjectList
        isCardView={true}
        searchText={searchText}
        hasDisabledRow={false}
        requiredPermission={ActivePermission.ACTIVE_PERMISSION_EDITOR}
        onUpdateData={onUpdateData}
        onSelect={(_id, project) => setProject(project)}
      />
      <div className={classNames.buttons}>
        <Button styles={buttonStylesGhost} style={{ marginRight: 8 }} text="Cancel" onClick={onCancel} />
        <Button
          styles={[buttonStylesPrimary, buttonStylesPrimaryPanel]}
          text="Select"
          disabled={!project}
          onClick={() => onSelect(project)}
        />
      </div>
    </div>
  );
};
